<template>
    <el-popover
        ref="letter-create"
        placement="top"
        title=""
        width="760"
        trigger="manual"
        v-model="showLetterForm"
        :visible-arrow="false"
        popper-class="event-letter-create"
        v-on-clickaway="hideLetterForm"
    >
        <el-row class="mb10">
            <el-col :span="24">
                <el-input v-model="fromName" readonly autocomplete="off" size="mini" />
            </el-col>
        </el-row>
        <el-row class="mb10">
            <el-col :span="2" class="form-label">
                Кому
            </el-col>
            <el-col :span="3">
                <el-radio v-model="receiverType" label="contact" class="form-radio">
                    Клиенту
                </el-radio>
            </el-col>
            <el-col :span="3">
                <el-radio v-model="receiverType" label="employer" class="form-radio">
                    Сотруднику
                </el-radio>
            </el-col>
            <el-col :span="16">
                <el-select
                    v-model="receiverId"
                    placement="bottom"
                    popper-class="popper-dropdown"
                    clearable
                    autocomplete
                    size="mini"
                >
                    <el-option v-for="item in receiverList" :key="item.id" :label="`${item.name} (${item.email})`" :value="item.id" />
                </el-select>
                <div class="form-error" v-if="errors.receiverId" v-text="errors.receiverId[0]"></div>
                <div class="form-error" v-if="errors.receiverType" v-text="errors.receiverType[0]"></div>
            </el-col>
        </el-row>
        <el-row class="mb10">
            <el-col :span="2" class="form-label">
                Копия
            </el-col>
            <el-col :span="22">
                <el-input v-model="copy" autocomplete="on" size="mini" clearable />
                <div class="form-error" v-if="errors.copy" v-text="errors.copy[0]"></div>
            </el-col>
        </el-row>
        <el-row class="mb10">
            <el-col :span="2" class="form-label">
                Тема
            </el-col>
            <el-col :span="22">
                <el-input v-model="subject" autocomplete="on" size="mini" clearable />
                <div class="form-error" v-if="errors.subject" v-text="errors.subject[0]"></div>
            </el-col>
        </el-row>
        <el-row class="mb16">
            <el-col>
                <el-input
                    type="textarea"
                    :rows="19"
                    placeholder=""
                    v-model="text"
                />
            </el-col>
        </el-row>
        <el-row class="mb16">
            <el-col :span="1">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleChange"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="files"
                    :show-file-list="false"
                >
                    <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                </el-upload>
            </el-col>
            <el-col :span="23" class="form-file-list event-attachments ">
                <el-tag
                    v-for="file in files"
                    :key="file.name"
                    closable
                    :type="''"
                    @close="handleClose(file)"
                    size="mini"
                    :disable-transitions="true"
                >
                    {{ file.name }}
                </el-tag>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-button type="warning" @click="createLetter">
                    Отправить
                </el-button>
                <el-button type="info" @click="hideLetterForm">
                    Отменить
                </el-button>
            </el-col>
        </el-row>
    </el-popover>
</template>

<script>
import '@/assets/styles/events.scss';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    name: 'EventLetterCreate',
    mixins: [
        clickaway
    ],
    data() {
        return {
            employer: null,
            showLetterForm: false,
            receiverType: null,
            receiverId: null,
            copy: null,
            subject: null,
            text: null,
            files: [],
            canSendLetter: true
        };
    },
    props: {
        entityType: {
            type: String,
            default: 'lead'
        },
        entityId: {
            type: Number,
            default: 0
        },
        entity: {
            type: Object,
            default: () => {}
        },
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.text = this.signature;
    },
    computed: {
        fromName() {
            return this.$store.state.auth.name;
        },
        receiverList() {
            if (this.receiverType === 'employer') {
                return this.$store.state.references.employers;
            }
            if (this.receiverType === 'contact') {
                return this.entity.contact_id ? [
                    {
                        id: this.entity.contact_id,
                        name: this.entity.contact.name,
                        email: this.entity.contact.email
                    }
                ] : [];
            }
            return [];
        },
        errors() {
            return this.$store.state.events.errors;
        },
        signature() {
            return `
___
С уважением, ${this.fromName}
${this.$store.state.auth.employer.user.email}
Телефон: ${this.$store.state.auth.officePhone} (${this.$store.state.auth.employer.internal_number})
`;
        }
    },
    methods: {
        hideLetterForm(event) {
            if (this.showLetterForm && event.target.className !== 'messages-menu-action') {
                this.showLetterForm = false;
                this.$emit('changeVisibility', false);
                this.resetForm();
            }
        },
        resetForm() {
            this.$store.commit('events/clearErrors');
            this.canSendLetter = true;
            this.receiverType = null;
            this.receiverId = null;
            this.copy = null;
            this.subject = null;
            this.files = [];
            this.text = this.signature;
        },
        showLetterFormVisible() {
            this.showLetterForm = true;
            this.$emit('changeVisibility', true);
        },
        handleChange(file, fileList) {
            this.files = fileList;
        },
        handleExceed() {
            this.$message({
                showClose: true,
                message: 'Внимание, лимит 10 файлов!',
                type: 'warning',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        handleClose(tag) {
            this.files.splice(this.files.indexOf(tag), 1);
        },
        handleTagClick(tag) {
        },
        createLetter() {
            if (!this.canSendLetter) {
                this.$message({
                    showClose: true,
                    message: 'Нельзя отправить письмо',
                    type: 'error',
                    duration: 5000,
                    customClass: this.alertClass()
                });
                return;
            }
            const params = {
                receiverId: this.receiverId,
                receiverType: this.receiverType,
                copy: this.copy,
                subject: this.subject,
                text: this.text,
                files: this.files,
                entityType: this.entityType,
                entityId: this.entityId
            };
            this.$store.dispatch('events/createLetter', params).then(() => {
                this.showLetterForm = false;
                this.$emit('changeVisibility', false);
                this.resetForm();
            }).catch(() => { });
        }
    },
    watch: {
        isVisible(value) {
            this.showLetterForm = value;
        },
        receiverType(value, prevValue) {
            if (value === 'contact') {
                let message = '';
                if (this.entity.contact_id === null) {
                    message = 'Нет связанного Клиента (контакта)';
                }
                if (this.entity.contact_id && this.entity.contact.email === '') {
                    message = 'Для отправки письма Клиенту необходимо указать в карточке Клиента e-mail';
                }
                if (message.length) {
                    this.$message({
                        showClose: true,
                        message: message,
                        type: 'error',
                        duration: 5000,
                        customClass: this.alertClass()
                    });
                    this.canSendLetter = false;
                    this.receiverType = prevValue;
                } else {
                    this.receiverId = this.entity.contact_id;
                    this.canSendLetter = true;
                }
            } else {
                this.canSendLetter = true;
                this.receiverId = null;
            }
        },
        fromName(value) {
            if (value) {
                this.text = this.signature;
            }
        }
    }
};
</script>
